import { StyledCardTitle, StyledDetailPageHeading, StyledPortalHeaderTitle } from "./atoms.styles";

export const CardTitle = ({ title, ...props }) => {
  return <StyledCardTitle {...props}>{title}</StyledCardTitle>;
};

/**
 * DetailPageTopBarHeading
 *
 * Renders the styled heading element used within a detail‑page top bar, wrapping
 * its children with `StyledDetailPageHeading`.
 *
 * Props
 * - children (React.ReactNode): the heading text or elements to display.
 * - …rest (HTMLAttributes<HTMLElement>): additional props passed directly to
 *   the underlying styled component.
 */

// DEPRECATED: Replace with <TopBarHeading />. Removal after 2025-10-09.
// DO-NOT-USE: Stop importing this component anywhere new.
// MIGRATE: Update existing screens to <TopBarHeading />.
// USE: <TopBarHeading /> is the canonical top bar heading component.
// @owner: Krishan_Siwach
export const DetailPageTopBarHeading = ({ children, ...rest }) => {
  return <StyledDetailPageHeading {...rest}>{children}</StyledDetailPageHeading>;
};

// USE: Preferred heading going forward.
// MIGRATE: Swap <DetailPageTopBarHeading /> → <TopBarHeading /> in all modules.
export const TopBarHeading = ({ children, ...rest }) => {
  return <StyledDetailPageHeading {...rest}>{children}</StyledDetailPageHeading>;
};

/**
 * PortalTitle
 *
 * Renders a styled title element for portal headers.
 *
 * Params
 * - title (string): The text content to display inside the modal title.
 * - ...rest (object): Any additional props (e.g., className, id) forwarded to the styled component.
 *
 * Returns
 * - React.ReactElement: A StyledPortalHeaderTitle element containing the provided title text.
 */
export const PortalTitle = ({ title, ...rest }) => {
  return <StyledPortalHeaderTitle {...rest}>{title}</StyledPortalHeaderTitle>;
};
